export const criticalDueConstants= {
 
    GET_DIRECT_CRITICAL_DUE_REQUEST: 'GET_DIRECT_CRITICAL_DUE_REQUEST',
    GET_DIRECT_CRITICAL_DUE_SUCCESS: 'GET_DIRECT_CRITICAL_DUE_SUCCESS',
    GET_DIRECT_CRITICAL_DUE_FAILURE: 'GET_DIRECT_CRITICAL_DUE_FAILURE',
}